import cn from 'classnames';
import _ from 'lodash';
import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import OrdersApi from '../../../../API/shipment/orders-api';
import close from '../../../../assets/media/icons/close.svg';
import edit_icon from '../../../../assets/media/icons/edit_icon.svg';
import iconExcel from '../../../../assets/media/icons/excel.svg';
import { Column, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button, CheckButton, SendButton } from '../../../../components/Basic/Buttons';
import { LinkBlue, Switch } from '../../../../components/Basic/Elements';
import { Content } from '../../../../components/Basic/Global';
import { DateInput, Input, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine, TablePagination } from '../../../../components/Basic/Table';
import { H1, Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import { MAP_SKLAD, TYPE_BUTTONS } from '../../../../constans';
import { getDateSolid, getProviderNew, setDateSolid } from '../../../../utils';
import ChangeBillPopUp from './ChangeBillPopUp';
import DeletePopUp from './DeletePopUp';
import OrderBillItemsLine from './OrderBillItemsLine';
import OrderLine from './OrderLine';
import OrderTable from './OrderTable';
import styles from './styles.module.scss';


const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

const LIST_MARKETS = [
  { name: 'Не выбран', value: undefined },
  { name: 'Все', value: ['ozon', 'yandex', 'wb'] },
  { name: 'Wb', value: ['wb'] },
  { name: 'Ozon+Yandex', value: ['ozon', 'yandex'] },
];

const IP_LIST = [
  { name: 'Макаров А.Н.', value: 2 },
  { name: 'Макаров Н.Н.', value: 1 },
  { name: 'Макаров А.С.', value: 3 },
  { name: 'Гудилина И.А.', value: 5 },
  { name: 'Гудилина Д.О.', value: 7 },
  { name: 'Кравец С.П.', value: 4 },
  { name: 'Кравец Т.С.', value: 6 },
];


let abortController = new AbortController();

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex'];

const MODES = ['Закупка', 'Листы'];
const MODES_OWNER = ['Закупка', 'Листы'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '330px', // 14
  '80px', // 15
  '115px', // 16
];

const STATUSES = ['Не выбран', 'Нет в наличии', 'Заказано', 'Не заказано', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];

const FILTER_BUY = {
  0: 'all',
  1: 'no_list',
  2: 'not_ordered',
  3: 'available',
  4: 'overage',
  5: 'not_enough',
  6: 'reserved',
  7: 'is_minus',
  8: 'not_available',
  9: 'rebuy',
};

const FILTER_LIST = {
  0: 'all_list',
  1: 'no_list_list',
  2: 'has_list',
};

const NAVIGATE = {
  'Закупка': [
    'Все заказы',
    'Без листа',
    'Не заказано',
    'В наличии',
    'Излишки',
    'Не хватает',
    'Резерв',
    'В минус',
    'Нет в наличии',
    'Перекуп',
  ],
  'Листы': ['Все выгрузки', 'Без листа', 'С листом'],
};

const FILTER = {
  'Закупка': FILTER_BUY,
  'Листы': FILTER_LIST,
};

function OrderPage({ }) {
  const { id } = useParams();

  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();
  // const [checkAll, setCheckAll] = useState(false);
  // const shipmentMode = 'Закупка';

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.focus();
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const searchBillRef = useRef(null);


  const [listMarkets, setListMarkets] = useState({ name: 'Не выбран', value: undefined });
  const [listMarketsSelect, setListMarketsSelect] = useState({ name: 'Не выбран', value: undefined });
  const [market, setMarket] = useState(MARKETS_LIST[0]);
  // const [market, setMarket] = useState({ name: 'Не выбран', value: undefined });
  const [shop, setShop] = useState('Все');
  const [mode, setMode] = useState(MODES[0]);

  const [orderInfo, setOrderInfo] = useState({});

  const [count, setCount] = useState([]);
  const [countPages, setCountPages] = useState([]);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  // const [searchBill, setSearchBill] = useState('');
  const [pricesMode, setPricesMode] = useState(false);
  const [rebuyMode, setRebuyMode] = useState(false);
  const [isAutoFillBill, setIsAutoFillBill] = useState(false);
  const [showModalDateArrive, setShowModalDateArrive] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalChangeBill, setShowModalChangeBill] = useState({ isActive: false });
  const [modalFunctionDelete, setModalFunctionDelete] = useState(() => () => { });
  const [dateBillArrive, setDateBillArive] = useState(new Date(setDateSolid(moment().startOf('day').add(1, 'day'))));
  const [ipPurcahse, setIpPurchase] = useState(IP_LIST[0]);

  const [tab, setTab] = useState(0);
  const [tabList, setTabList] = useState(0);

  const [countStock, setCountStock] = useState([0]);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const [providersStat, setProvidersStat] = useState([]);
  const [providerAmount, setProviderAmount] = useState([]);
  const [providersStatFilter, setProvidersStatFilter] = useState({});
  const [status, changeStatus] = useState(STATUSES[0]);

  const [postitionsChecked, setPositionsChecked] = useState({});
  const [checkAll, setCheckAll] = useState(false);

  const [orders, setOrders] = useState({ ids: [], byIds: {}, map: {} });
  const [lists, setLists] = useState({ ids: [], byIds: {} });
  // const [lists, setLists] = useState([]);

  const [ordersBill, setOrdersBill] = useState([]);
  const [ordersBillFiltered, setOrdersBillFiltered] = useState([]);

  const [billsMap, setBillsMap] = useState({});
  const [billsAmount, setBillsAmount] = useState({});
  const [productAltsMap, setProductAltsMap] = useState({});

  const [filteredBillsMap, setFilteredBillsMap] = useState({});
  const [billFilter, setBillFilter] = useState({});
  const [billNumber, setBillNumber] = useState('');

  const [showOrderTable, setShowOrderTable] = useState(false);

  const allProviders = useSelector((store) => store.providers);


  const getListColor = (lm) => {
    let color
    const listName = LIST_MARKETS.find(LM => _.isEqual(LM.value, lm))?.name
    switch (listName) {
      case 'Все': color = '#00dae65e'; break
      case 'Ozon+Yandex': color = '#aa00cc65'; break
      case 'Wb': color = '#84b1f99d'; break
    }
    return { listName, color }
  }

  const onChangeOrderData = async ({ orderProductId, field, value, action }) => {
    return OrdersApi.changeOrderData({ data: { orderId: +id, orderProductId, field, value, action } }).then(() => loadData());
  };

  const onChangeOrdersData = async ({ orderProductIds, field, value }) => {
    OrdersApi.changeOrdersData({ data: { orderId: +id, orderProductIds, field, value } }).then(() => loadData());
  };

  const onChangeOrdersList = async ({ orderProductIds, field, value }) => {
    OrdersApi.changeOrdersData({ data: { orderId: +id, orderProductIds, field, value } }).then(() => loadLists());
  };

  const onChangeBillItem = ({ billItemId, field, value }) => {
    OrdersApi.changeBillItem({ data: { billItemId, field, value } }).then(() => loadData());
  };

  const onChangeBill = ({ billId, newBill, field, value }) => {
    OrdersApi.changeBill({ data: { billId, newBill, field, value } }).then(() => {
      if (mode === 'Закупка') loadData()
      if (mode === 'Листы') loadLists();
    });
  };

  const changePositionsCheck = (id) => {
    if (postitionsChecked[id]) {
      const s = postitionsChecked;
      delete s[id];
      setPositionsChecked({ ...s });
    } else {
      setPositionsChecked({ ...postitionsChecked, [id]: true });
    }
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const mapSelect = {};

      if (mode === 'Закупка') {
        orders.ids.forEach((item) => {
          mapSelect[orders.byIds[item]._id] = true;
        });
      }
      if (mode === 'Листы') {
        lists.ids.forEach((item) => {
          mapSelect[lists.byIds[item].id] = true;
        });
      }

      setPositionsChecked(mapSelect);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setPositionsChecked({});
    }
  };

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
    setPage(1);
  };

  const params = useMemo(() => {
    const s = status === STATUSES[0] ? '' : status;
    const shopName = shop === 'Все' ? '' : shop;
    let orderIds = id.split('&');
    orderIds = orderIds.map((item) => parseInt(item));

    return {
      orderIds,
      shipmentFilter: undefined,
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[mode][tab],
      shop: shopName,
      market: market === 'Не выбрана' ? '' : market.toLocaleLowerCase(),
      listMarkets: listMarkets.name === 'Не выбран' ? undefined : listMarkets.value,
      sortType: 'shipments',
      filters: {
        productsStatus: s,
        billFilter,
      },
    };
  }, [id, show, mode, page, search, tab, provider.id, status, shop, market, listMarkets, billFilter]);

  const params_lists = useMemo(() => {
    let orderIds = id.split('&');
    orderIds = orderIds.map((item) => parseInt(item));

    return {
      orderIds,
      limit: parseInt(show),
      page,
      providerId: provider.id,
      tab: FILTER[mode][tab],
      market: market === 'Не выбрана' ? '' : market.toLocaleLowerCase(),
      listMarkets: listMarkets.name === 'Не выбран' ? undefined : listMarkets.value,
      sortType: 'shipments',
    };
  }, [id, show, mode, page, tab, provider.id, market, listMarkets]);

  const loadData = async () => {
    abortController.abort(); // Cancel the previous request
    abortController = new AbortController();

    OrdersApi.getOrderProductsItems({ data: params, signal: abortController.signal })
      .then((res) => {
        const {
          orderProducts,
          pagesCount,
          orderProductsItems,
          providerStatistic,
          cardsMap,
          count,
          all_count,
          amountOrderedQuantity,
          billsMap,
          billsAmount,
          providerAmount,
          productAltsMap
        } = res;
        const byIds = {};
        setCountStock([
          all_count.all,
          all_count.no_list,
          all_count.not_ordered,
          all_count.available,
          all_count.overage,
          all_count.not_enough,
          all_count.reserved,
          all_count.is_minus,
          all_count.not_available,
          all_count.rebuy,
        ]);

        const ids = orderProductsItems.map((item) => item._id);
        orderProductsItems.forEach((item) => (byIds[item._id] = item));

        setOrders({ byIds, ids, map: cardsMap });
        setProductAltsMap(productAltsMap);
        setBillsMap(billsMap);
        setBillsAmount(billsAmount);
        setOrderInfo(orderProducts)
        setFilteredBillsMap(billsMap);
        setPositionsChecked({});
        setOrdersBill(amountOrderedQuantity);
        setOrdersBillFiltered(amountOrderedQuantity);
        setCount(count);
        setCountPages(pagesCount);
        setProvidersStat(providerStatistic || []);
        setProviderAmount(providerAmount)

      })
      .catch((err) => {
        console.log(err);
        // if (err.code === 140) {
        // setError('Не удалось отгрузку');
        // }
      });
  };

  const loadLists = async () => {
    OrdersApi.getLists({ data: params_lists }).then((r) => {
      const { all_count } = r;

      const lists = r.lists.map(l => ({ ...l, id: `${l._id.dates_create}-${l._id.provider_id}` }))

      const ids = lists.map((item) => item.id);
      const byIds = {};
      lists.forEach((item) => (byIds[item.id] = item));

      setLists({ byIds, ids });
      // setLists(r.lists);
      console.log(r, all_count);

      setCountStock([all_count.all_list, all_count.no_list_list, all_count.has_list]);
    });
  };

  useEffect(() => {
    if (mode === 'Закупка') {
      loadData();
    }
    if (mode === 'Листы') {
      loadLists();
    }
    setCheckAll(false);
    setPositionsChecked({});
  }, [params, params_lists, mode]);

  // useEffect(() => {
  //   const p = allProviders.filter((item) => !item.hide);
  //   if (p.length > 0) {
  //     changeProvider({ name: 'Не выбран', id: null });
  //   } else {
  //     changeProvider({ name: '' });
  //   }
  // }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  const tab_name = 'Оформление заказов';

  const modes = isOwner ? MODES_OWNER : MODES;

  // useEffect(() => {
  //   setShop('Все');
  // }, [market]);

  const getColorStatCondition = ({ all, ordered, not_available = 0 }) => {
    const allHave = ordered + not_available
    let color;
    // if (all === ordered) return '#2bff00bb';
    if (all === allHave) return '#42c72898';
    if (allHave === 0) return '#fa8072c4';
    if (allHave > 0) return 'rgb(255 235 59 / 50%)';
  };

  return (
    <>
      <Content>
        <H1 style={{ marginBottom: '-3px' }}>{'Оформление заказов' + (orderInfo.dates ? ` ${orderInfo.dates && moment(getDateSolid(orderInfo?.dates?.scheduled)).format('DD.MM.YYYY')} ${orderInfo.sklad_name && MAP_SKLAD[orderInfo?.sklad_name]}` : '')}</H1>
        <LinkBlue to='/orders/' style={{ marginBottom: '10px' }}>
          Вернуться к заказам
        </LinkBlue>
        <Row style={{ alignItems: 'flex-start' }}>
          <WhiteBlock title="Поставщик" title_bold={provider.id && provider.name} style={{ width: '100%' }}>
            <Row style={{ alignItems: 'flex-end', marginBottom: '20px', marginTop: '-10px' }}>
              <Select
                width={'200px'}
                label="Поставщик"
                select={provider}
                valueFn={(p) => p.name}
                // list={providers}
                list={[
                  { name: 'Не выбран', id: null },
                  ...providersStat
                    .map((p) => ({ all: p.all, id: p._id, name: getProviderNew(p._id, allProviders)?.name }))
                    .sort((a, b) => b.all - a.all),
                ]}
                style={{ marginRight: '10px' }}
                onSelect={(v) => {
                  changeProvider(v);
                  setListMarkets(LIST_MARKETS.find(lm => !lm.value))
                  setBillFilter({ ...billFilter, ids: [] });
                }}
              />
              <Select
                list={provider.id ? [LIST_MARKETS.find(LM => !LM.value), ...(providersStat.find(p => p._id === provider.id)?.list_markets.filter(lm => lm.length > 0).map(lm => LIST_MARKETS.find(LM => _.isEqual(lm, LM.value))) || [])] : LIST_MARKETS}
                select={listMarkets}
                label="Лист"
                valueFn={(p) => p.name}
                onSelect={(v) => setListMarkets(v)}
                width={'150px'}
                style={{ marginRight: '15px' }}
              />
              <Button
                type={TYPE_BUTTONS.BLUE}
                onClick={
                  () => setShowOrderTable(true)
                  // doRequestDownload(API_ORDERS_EXCEL, 'POST', { orderId: id, providerId: provider.id, markets: market.value })
                }
                disabled={provider.name === 'Не выбран' || market.name === 'Не выбран' || listMarkets.name === 'Не выбран'}
                style={{ margin: '0 0px 0 105px' }}
              >
                Сформировать заказ
              </Button>
            </Row>
            <hr style={{ width: '100%', backgroundColor: '#4545459c', height: '1px', border: 'none' }} />
            <>
              <Row style={{ marginTop: '20px' }}>
                <div style={{ width: '200px' }}>
                  <Input
                    // label='Номер счета'
                    value={billNumber}
                    onBlur={(v) => {
                      setBillNumber(v);
                    }}
                    disabled={isAutoFillBill}
                    placeholder={'Номер счёта'}
                  />
                </div>
                <Row
                  style={{ cursor: 'pointer', marginLeft: '5px' }}
                  onClick={() => {
                    setBillNumber('');
                    setIsAutoFillBill(!isAutoFillBill);
                  }}
                >
                  <CheckButton
                    small={true}
                    checked={isAutoFillBill}
                    onSelect={() => {
                      setBillNumber('');
                      setIsAutoFillBill(!isAutoFillBill);
                    }}
                  />
                  <div style={{ color: 'gray', marginLeft: '5px', font: '12px' }}>авто</div>
                </Row>
                <Button style={{ marginLeft: '115px' }} type={TYPE_BUTTONS.WHITE}
                  onClick={() =>
                    OrdersApi.excelTemplateUpload({})
                  }>
                  Шаблон
                </Button>
                <SendButton
                  style={{ marginLeft: '15px' }}
                  sendApi={OrdersApi.loadOrderData}
                  sendData={{
                    data: {
                      ipId: ipPurcahse.value,
                      orderId: parseInt(id),
                      providerId: provider.id,
                      billNumber,
                      autoBill: isAutoFillBill,
                      listMarkets: listMarkets.value,
                      dateArrive: dateBillArrive,
                    }
                  }}
                  endLoad={loadData}
                  disabled={
                    provider.name === 'Не выбран' ||
                    listMarkets.name === 'Не выбран' ||
                    (billNumber === '' && !isAutoFillBill)
                  }
                >
                  Подгрузить шаблон
                </SendButton>

              </Row>
              <Row>
                <div style={{ margin: '0px 0px 10px 0px' }}>
                  <DateInput
                    label="Дата прибытия"
                    // className={styles.date_input}
                    classNameCalendar={styles.date_input_calendar}
                    value={getDateSolid(dateBillArrive)}
                    onChange={(v) => setDateBillArive(setDateSolid(v))}
                  />
                </div>
                <div style={{ margin: '0px 0px 0px 30px' }}>
                  <Select
                    greyLabel={true}
                    label="ИП закупки"
                    select={ipPurcahse}
                    list={IP_LIST}
                    width='150px'
                    valueFn={(v) => v.name}
                    onSelect={(v) => {
                      setIpPurchase(v)
                    }} />
                </div>
                <SendButton
                  sendApi={OrdersApi.loadOrderData}
                  sendData={{
                    data: {
                      ipId: ipPurcahse.value,
                      orderId: parseInt(id),
                      providerId: provider.id,
                      billNumber,
                      autoBill: isAutoFillBill,
                      listMarkets: listMarkets.value,
                      dateArrive: dateBillArrive,
                      formatType: 'order',
                    }
                  }}
                  style={{ marginLeft: '35px' }}
                  endLoad={loadData}
                  disabled={
                    provider.name === 'Не выбран' ||
                    listMarkets.name === 'Не выбран' ||
                    (billNumber === '' && !isAutoFillBill)
                  }
                >
                  Подгрузить заказ
                </SendButton>

                <SendButton
                  sendApi={OrdersApi.loadOrderData}
                  sendData={{
                    data: {
                      ipId: ipPurcahse.value,
                      orderId: parseInt(id),
                      providerId: provider.id,
                      billNumber,
                      autoBill: isAutoFillBill,
                      listMarkets: listMarkets.value,
                      dateArrive: dateBillArrive,
                      formatType: 'bill',
                    }
                  }}
                  style={{ marginLeft: '15px' }}
                  endLoad={loadData}
                  disabled={
                    provider.name === 'Не выбран' ||
                    listMarkets.name === 'Не выбран' ||
                    (billNumber === '' && !isAutoFillBill)
                  }
                >
                  Подгрузить счёт
                </SendButton>
              </Row>
            </>
          </WhiteBlock>
          <WhiteBlock title="Сводка" left={true} minimize={true} openBlock={false} style={{ marginLeft: '15px' }}>
            {/* <Row style={{ width: '170px', position: 'relative', bottom: '50px', left: '80px' }}> */}
            <Row style={{ width: '80%', justifyContent: 'space-between', position: 'relative', bottom: '53px', left: '100px' }}>
              <Row>
                <Switch switched={providersStatFilter?.onlyNotEnded} onClick={(v) => setProvidersStatFilter({ onlyNotEnded: v })} />
                <TextGrey style={{ marginLeft: '5px' }}>Не в ноль</TextGrey>
              </Row>
              <div style={{ color: '#353535ad', fontWeight: '700' }} >{`Кол: ${providerAmount?.ordered || 0} / ${providerAmount?.all || 0},  Сумма: ${providerAmount?.sum || 0}`}</div>
            </Row>
            <table style={{ boxShadow: '2px 2px 2px rgba(109, 109, 109, 0.42)' }} className={styles.table_stat}>
              <thead>
                <tr>
                  <th
                    style={{ cursor: 'pointer' }}
                    className={styles.td_select}
                    onClick={() => {
                      changeProvider({ name: 'Не выбран', id: null });
                      setBillFilter({ ...billFilter, ids: [] });
                      setListMarkets(LIST_MARKETS.find(lm => !lm.value))
                    }}
                  >
                    Поставщик
                  </th>
                  <th>Заказано</th>
                  <th>Сумма</th>
                  <th
                    style={{ cursor: 'pointer', textAlign: 'center' }}
                    className={styles.td_select}
                    colSpan={3}
                    onClick={() => {
                      // changeProvider({ name: 'Не выбран', id: null });
                      setBillFilter({ ...billFilter, ids: [] });
                      setListMarkets(LIST_MARKETS.find(lm => !lm.value))
                    }}>Листы</th>
                </tr>
              </thead>
              <tbody>
                {providersStat
                  .filter(p => {
                    if (providersStatFilter?.onlyNotEnded) return (p.ordered + p.not_available) < p.all
                    return p
                  })
                  .map((p) => ({
                    ...p,
                    is_stock: getProviderNew(p._id, allProviders).is_stock,
                    name: getProviderNew(p._id, allProviders)?.name,
                  }))
                  .sort((a, b) => b.all - a.all)
                  .map((p) => {
                    return (
                      // style={{ backgroundColor: getColorStatCondition({ ordered: p.ordered, all: p.all, reserved: p.reserved }), padding: '5px', border: '0.5px solid gray' }
                      <tr key={p._id}>
                        <td
                          style={{
                            cursor: 'pointer',
                            backgroundColor: getColorStatCondition({
                              ordered: p.ordered,
                              not_available: p.not_available,
                              all: p.all,
                              // reserved: p.reserved,
                            }),
                            width: '130px',
                          }}
                          className={cn(
                            styles.td_select,
                            !allProviders.find((pr) => pr.id === p._id).is_stock && styles.big_provider,
                          )}
                          onClick={() => {
                            changeProvider({ name: p.name, id: p._id });
                            setBillFilter({ ...billFilter, ids: [] });
                            setListMarkets(LIST_MARKETS.find(LM => !LM.value))
                          }}
                        >
                          {p.name}
                        </td>
                        <td className={cn(p._id === provider.id && styles.active)}>{p.not_available ? <span style={{ fontWeight: 'bold', color: '#d41616a7' }}>{`${p.not_available} + `}</span> : ''}{`${p.ordered} / ${p.all}`}</td>
                        {/* <td className={cn(p._id === provider.id && styles.active)}>{p.sum}</td> */}
                        <td style={{ textAlign: 'center' }} className={cn(p._id === provider.id && styles.active)}>{+p?.sum?.toFixed(2)}</td>
                        {
                          LIST_MARKETS.filter(LM => LM.value).reduce((acc, LM) => {
                            acc.push(p.list_markets.find(lm => _.isEqual(lm, LM.value)) ? LM.value : []); return acc
                          }, []).map((lm, i) => {
                            return (
                              < td key={i} style={{ textAlign: 'center', ...(lm.length > 0 && { cursor: 'pointer' }) }} className={cn(
                                lm.length > 0 && styles.td_select_transparent, p._id === provider.id && styles.active,
                                _.isEqual(listMarkets.value, lm) && styles.active_2,
                              )}
                                onClick={() => {
                                  if (lm.length > 0) {
                                    changeProvider({ name: p.name, id: p._id });
                                    setBillFilter({ ...billFilter, ids: [] });
                                    setListMarkets(LIST_MARKETS.find(LM => _.isEqual(LM.value, lm)))
                                  }
                                }}
                              >{LIST_MARKETS.find(LM => _.isEqual(LM.value, lm))?.name}</td>
                            )
                          })
                        }
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </WhiteBlock>
          <WhiteBlock title="Счета" left={true} minimize={true} openBlock={false} style={{ marginLeft: '15px' }}>
            <Row style={{ width: '90%', justifyContent: 'space-between', position: 'relative', bottom: '53px', left: '90px' }}>
              <Row>
                <Switch switched={billFilter?.noToShipment} onClick={(v) => setBillFilter({ ...billFilter, noToShipment: v })} />
                <TextGrey style={{ marginLeft: '5px' }}>Нет на отгрузку</TextGrey>
              </Row>
              <div style={{ color: '#353535ad', fontWeight: '700' }} >{`Кол: ${billsAmount?.count || 0},  Сумма: ${billsAmount?.sum || 0}`}</div>
            </Row>
            <table style={{ boxShadow: '2px 2px 2px rgba(109, 109, 109, 0.42)' }} className={styles.table_stat}>
              <thead>
                <tr>
                  <th
                    style={{ cursor: 'pointer' }}
                    className={styles.td_select}
                    onClick={() => {
                      setListMarkets(LIST_MARKETS.find(lm => !lm.value))
                    }}
                  >Лист</th>
                  <th
                    style={{ cursor: 'pointer' }}
                    className={styles.td_select}
                    onClick={() => {
                      changeProvider({ name: 'Не выбран', id: null });
                      setBillFilter({ ...billFilter, ids: [] });
                      setListMarkets(LIST_MARKETS.find(lm => !lm.value))
                    }}
                  >Поставщик</th>
                  <th
                    style={{ cursor: 'pointer' }}
                    className={styles.td_select}
                    onClick={() => {
                      setBillFilter({ ...billFilter, ids: [] });
                    }}
                    colSpan="4">Номер счета</th>
                  <th>Дата прихода</th>
                  <th>Закупочное ИП</th>
                  <th>Кол.</th>
                  <th>Сумма</th>
                </tr>
              </thead>
              <tbody>
                {Object.values(billsMap)
                  .sort((a, b) => new Date(a.dates?.create).getTime() - new Date(b.dates?.create).getTime())
                  .sort((a, b) => a.list_markets?.length - b.list_markets?.length)
                  .sort((a, b) => providersStat.find(ps => ps._id === b.provider_id).all - providersStat.find(ps => ps._id === a.provider_id).all)
                  .map((p) => {
                    return (
                      <tr key={p._id}>
                        <td
                          style={{ cursor: 'pointer', }}
                          className={cn(styles.td_select_transparent)}
                          onClick={() => {
                            changeProvider({ name: getProviderNew(p.provider_id, allProviders)?.name, id: p.provider_id });
                            setBillFilter({ ...billFilter, ids: [] });
                            setListMarkets(LIST_MARKETS.find(LM => _.isEqual(LM.value, p.list_markets)))
                          }}
                        >{LIST_MARKETS.find(LM => _.isEqual(LM.value, p.list_markets))?.name}</td>
                        <td
                          style={{ cursor: 'pointer' }}
                          className={cn(styles.td_select_transparent, p.rebuy && styles.rebuy_color, p.rebuy && styles.td_select)}
                          onClick={() => {
                            changeProvider({ name: getProviderNew(p.provider_id, allProviders)?.name, id: p.provider_id });
                            setBillFilter({ ...billFilter, ids: [] });
                            setListMarkets(LIST_MARKETS.find(LM => !LM.value))
                          }}
                        >{p.rebuy?.other_shop?.name || getProviderNew(p.provider_id, allProviders)?.name}</td>

                        <td
                          className={cn(
                            styles.td_select,
                            styles.td_select_transparent,
                            billFilter.ids?.includes(p.id) && styles.active,
                          )}
                          style={{ cursor: 'pointer', minWidth: '60px' }}
                          onClick={(e) => {
                            let newBillFilterIds = billFilter.ids?.includes(p.id)
                              ? billFilter.ids?.filter((id) => id !== p.id)
                              : _.compact([...(billFilter.ids || []), p.id]);
                            setBillFilter({ ...billFilter, ids: newBillFilterIds });
                          }}
                        >
                          <span style={{ ...(p.dokup?.is ? { color: '#0ac900c9', fontWeight: 'bold' } : p.dokup?.has ? { color: '#a1a700da', fontWeight: 'bold' } : {}) }}>{p.number}</span>
                        </td>
                        <td
                          className={cn(styles.icon, styles.excel)}
                          onClick={() => {
                            setShowModalChangeBill({ isActive: true, bill: p })
                            // onChangeBill({ billId: p.id, field: 'number', value: v });
                          }}
                        >
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src={edit_icon} style={{ width: '20px' }} />
                          </div>
                        </td>
                        <td
                          className={cn(styles.icon, styles.excel)}
                          onClick={() => {
                            OrdersApi.downloadBill({ data: { billId: p.id } })
                          }}
                        >
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src={iconExcel} style={{ width: '20px' }} />
                          </div>
                        </td>

                        <td
                          className={cn(styles.icon, styles.delete)}
                          onClick={() => {
                            setShowModalDelete(true);
                            setModalFunctionDelete(() => async () => {
                              await OrdersApi.deleteBill({ data: { billId: p.id } })
                              let newBillFilterIds = billFilter.ids?.filter((n) => n !== p.id);
                              setBillFilter({ ...billFilter, ids: newBillFilterIds });
                              // loadData()
                              setShowModalDelete(false);
                            });
                          }}
                        >
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src={close} style={{ width: '15px' }} />
                          </div>
                        </td>
                        <td style={{ width: '110px' }}>
                          <div>
                            <DateInput
                              // classNameCalendar={styles.date_input_calendar}
                              value={p.dates.arrive && getDateSolid(p.dates.arrive)}
                              onChange={(v) =>
                                onChangeBill({ billId: p.id, field: 'date_arrive', value: new Date(setDateSolid(v)) })
                              }
                            />
                          </div>
                        </td>
                        <td >
                          <Select
                            select={IP_LIST.find(IP => IP.value == p.ip_id)}
                            list={IP_LIST}
                            width='135px'
                            valueFn={(v) => v.name}
                            onSelect={(v) => {
                              onChangeBill({ billId: p.id, field: 'ip_id', value: v.value })
                            }} />
                        </td>
                        <td style={{ textAlign: 'center' }}>{p.count}</td>
                        <td>{+p?.sum?.toFixed(2)}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </WhiteBlock>
        </Row>

        {mode === 'Закупка' ? (
          <div style={{ display: 'inline-flex', width: '100%' }}>
            <Column style={{ width: '1500px', flexGrow: '2', flexBasis: '0' }}>
              <WhiteBlock className={styles.search_block}>
                <Row className={styles.navigate_table}>
                  <NavTabs
                    open_tab={tab}
                    tabs={NAVIGATE[mode]}
                    isNum={true}
                    num={countStock}
                    style_tab={styles.style_tab}
                    onChange={onChangeTab}
                    red_tab="Не заказано"
                  />
                  <Row>

                    <Select
                      select={mode}
                      list={modes}
                      onSelect={(v) => {
                        setTab(0)
                        setMode(v)
                      }} 
                      width="100px" />
                  </Row>
                </Row>
                <Row className={styles.row_input}>
                  {Object.keys(postitionsChecked).length > 0 ? (
                    <Row className={styles.row_select}>
                      <Row>

                        <Button
                          type={TYPE_BUTTONS.RED}
                          style={{ marginRight: '25px' }}
                          onClick={() => {
                            setCheckAll(false);
                            setPositionsChecked({});
                            setTimeout(setInputFocus, 1000);
                          }}
                        >
                          Очистить выбор
                        </Button>

                        <div style={{ margin: '-10px 20px 0px 0px' }}>
                          <DateInput
                            label="Дата отгрузки"
                            value={new Date()}
                            onChange={(v) =>
                              onChangeOrdersData({
                                orderProductIds: Object.keys(postitionsChecked),
                                field: 'date_arrive',
                                value: setDateSolid(v),
                              })
                            }
                            width={'140px'}
                          />
                        </div>

                        <Select
                          label="Лист"
                          width={'200px'}
                          select={listMarketsSelect}
                          valueFn={(v) => v.name}
                          list={LIST_MARKETS}
                          // style={{ marginRight: '10px' }}
                          onSelect={async (v) => {
                            await onChangeOrdersData({
                              // orderProductIds: lists.ids.filter(listId => Object.keys(postitionsChecked).includes(listId))
                              //   .reduce((acc, listId) => {
                              //     const itemsId = lists.byIds[listId].items
                              //     acc.push(...itemsId)
                              //     return acc
                              //   }, []),
                              orderProductIds: Object.keys(postitionsChecked),
                              field: 'list_markets',
                              value: v.value || [],
                            });
                            setPositionsChecked({})
                            // setListMarketsSelect(LIST_MARKETS.find(lm => !lm.value))

                          }}
                        />
                      </Row>
                    </Row>
                  ) : (
                    <Input
                      value={search}
                      ref={inputRef}
                      onBlur={(v) => setSearch(v)}
                      onClickEnter={(v) => setSearch(v)}
                      label="Поиск"
                    />
                  )}
                </Row>

                <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

                <Row spaceBetween={true}>
                  <Row style={{ height: '40px' }}>
                    <div>
                      <Select
                        label="Показать на странице"
                        select={show}
                        list={['20', '50', '100', '150', '200', '500', '1000']}
                        onSelect={(v) => setShow(v)}
                        width="150px"
                        style={{ marginRight: '15px' }}
                      />
                    </div>
                    <Select
                      list={MARKETS_LIST}
                      select={market}
                      // disabled={market === 'Все'}
                      label="Площадка"
                      onSelect={(v) => setMarket(v)}
                      width={'150px'}
                      style={{ marginRight: '15px' }}
                    />
                    <Select
                      list={SHOPS[market.toLocaleLowerCase()]}
                      select={market === 'Не выбрана' ? 'Все' : shop}
                      disabled={market === 'Не выбрана'}
                      label="Магазин"
                      onSelect={(v) => setShop(v)}
                      width={'150px'}
                      style={{ marginRight: '15px' }}
                    />
                    <Select
                      label="Статус товара"
                      select={status}
                      list={STATUSES}
                      width="200px"
                      onSelect={(v) => changeStatus(v)}
                      style={{ marginRight: '15px' }}
                    />
                  </Row>
                  <Row>
                    <Row style={{ marginRight: '25px' }}>
                      <TextGrey style={{ marginRight: '10px' }}>Перекуп</TextGrey>
                      <Switch switched={rebuyMode} onClick={(v) => setRebuyMode(v)} />
                    </Row>
                    <Row style={{ width: '170px', marginRight: '5px' }}>
                      <TextGrey style={{ marginRight: '10px' }}>Показать цены</TextGrey>
                      <Switch switched={pricesMode} onClick={(v) => setPricesMode(v)} />
                    </Row>
                  </Row>
                </Row>
              </WhiteBlock>

              <Table styles={styles.table}>
                <TableHeader whiteHeader>
                  <HeaderTitle width={WIDTH_POSTING[9]}>
                    <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[10]}>Поставщик</HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[1]}>Позиция</HeaderTitle>
                  <HeaderTitle width={'90px'} centerText={true}>
                    Площадка
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[16]} centerText={true}>
                    Лист
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>
                    Артикул поставщика
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[15]} centerText={true}>
                    Кол
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
                    Всего в наличии
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>
                    Статус товара
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>
                    Комментарий
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                    Город
                  </HeaderTitle>
                  {rebuyMode && (
                    <>
                      <HeaderTitle style={{ backgroundColor: '#657b7b3d' }} width={'100px'} centerText={true}>

                      </HeaderTitle>
                      <HeaderTitle style={{ backgroundColor: '#657b7b3d' }} width={WIDTH_POSTING[0]} centerText={true}>
                        Перекуп
                      </HeaderTitle>
                      <HeaderTitle style={{ backgroundColor: '#657b7b3d' }} width={WIDTH_POSTING[10]} centerText={true}>
                        УПД
                      </HeaderTitle>
                    </>
                  )}
                  {pricesMode && (
                    <>
                      <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                        Цена продажи
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                        Комиссия
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                        Цена закупки
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                        Прибыль
                      </HeaderTitle>
                    </>
                  )}

                  {/* <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>Расходы магазина</HeaderTitle> */}
                  {/* <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>Прибыль</HeaderTitle> */}
                  <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>
                    Дата прихода на склад
                  </HeaderTitle>
                  {/* <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>Отправлен заказ</HeaderTitle> */}
                  <HeaderTitle width={WIDTH_POSTING[7]} centerText={true}>
                    Штрихкод товара
                  </HeaderTitle>
                </TableHeader>
                {orders.ids.map((orderId) => {
                  return (
                    <OrderLine
                      listNameColor={getListColor(orders.byIds[orderId]?.list_markets)}
                      // isAdmin={isAdmin}
                      // shipmentMode={shipmentMode}
                      providers={allProviders}
                      productAlt={productAltsMap[orders.byIds[orderId].provider_sku]}
                      changePositionsCheck={changePositionsCheck}
                      postitionsChecked={postitionsChecked}
                      MODES={modes}
                      pricesMode={pricesMode}
                      rebuyMode={rebuyMode}
                      LIST_MARKETS={LIST_MARKETS}
                      // FILTER={FILTER}
                      // tab={tab}
                      order={orders.byIds[orderId]}
                      map={orders.map}
                      key={orders.byIds[orderId]._id}
                      onChangeOrderData={onChangeOrderData}
                    />
                  );
                })}
              </Table>

              {/* </div> */}

              <TablePagination num={countPages || 1} show={page} onChange={onChangePage} />
            </Column>
            <Column
              style={{ flexGrow: '1', flexBasis: '0', marginLeft: '30px' }}
            // style={{ minWidth: 'none!important',' }}
            >
              <WhiteBlock className={styles.search_block}>
                <Row className={styles.navigate_table}>
                  <NavTabs
                    open_tab={'Все товары'}
                    tabs={['Все товары']}
                    isNum={true}
                    num={[ordersBillFiltered.length]}
                    style_tab={styles.style_tab}
                    onChange={onChangeTab}
                  />
                </Row>
                <Row className={styles.row_input}>
                  <Input
                    ref={searchBillRef}
                    onBlur={(v) => setOrdersBillFiltered(ordersBill.filter(bill => `${bill.provider_sku.toLocaleLowerCase()}`.includes(v.trim().toLocaleLowerCase()) || `${bill.name.toLocaleLowerCase()}`.includes(v.trim().toLocaleLowerCase())))}
                    onClickEnter={(v) => setOrdersBillFiltered(ordersBill.filter(bill => `${bill.provider_sku.toLocaleLowerCase()}`.includes(v.trim().toLocaleLowerCase()) || `${bill.name.toLocaleLowerCase()}`.includes(v.trim().toLocaleLowerCase())))}
                    label="Поиск"
                  />
                </Row>
              </WhiteBlock>
              <Table style={{ overflow: 'auto', minWidth: '0px' }}>
                <TableHeader whiteHeader>
                  <HeaderTitle width={WIDTH_POSTING[15]}>
                    Номер
                  </HeaderTitle>
                  <HeaderTitle centerText={true} width={WIDTH_POSTING[16]}>
                    Лист
                  </HeaderTitle>
                  <HeaderTitle centerText={true} width={WIDTH_POSTING[0]}>
                    Артикул
                  </HeaderTitle>
                  <HeaderTitle centerText={true} width={WIDTH_POSTING[11]}>
                    Наименование
                  </HeaderTitle>
                  <HeaderTitle centerText={true} width={WIDTH_POSTING[15]}>
                    Кол.
                  </HeaderTitle>
                  <HeaderTitle centerText={true} width={WIDTH_POSTING[6]}>
                    Цена
                  </HeaderTitle>
                  <HeaderTitle centerText={true} width={WIDTH_POSTING[0]}>
                    Счёт
                  </HeaderTitle>
                </TableHeader>
                {/* {billFilter?.ids?.length === 1 && <AddBillItemLine
                  // isAdmin={isAdmin}
                  // packagingMode={packagingMode}
                  // FILTER={FILTER}
                  // tab={tab}
                  // shipmentMode={shipmentMode}
                  // MODES={modes}
                  listNameColor={getListColor(ordersBillFiltered?.[0]?.list_markets)}
                  billsMap={filteredBillsMap}
                  billItem={{ ...(ordersBillFiltered?.[0] || {}) }}
                // onChangeOrderData={onChangeOrderData}
                // onChangeBillItem={onChangeBillItem}
                />} */}
                {ordersBillFiltered.map((billItem, i) => {
                  return (
                    <OrderBillItemsLine
                      // isAdmin={isAdmin}
                      // packagingMode={packagingMode}
                      // FILTER={FILTER}
                      // tab={tab}
                      // shipmentMode={shipmentMode}
                      // MODES={modes}
                      listNameColor={getListColor(billItem?.list_markets)}
                      index={i + 1}
                      LIST_MARKETS={LIST_MARKETS}
                      billsMap={filteredBillsMap}
                      billItem={billItem}
                      key={billItem._id}
                      onChangeOrderData={onChangeOrderData}
                      onChangeBillItem={onChangeBillItem}
                    />
                  );
                })}
              </Table>
            </Column>
          </div>
        ) : (
          <>
            <WhiteBlock className={styles.search_block}>
              <Row className={styles.navigate_table}>
                <NavTabs
                  open_tab={tab}
                  tabs={NAVIGATE[mode]}
                  isNum={true}
                  num={countStock}
                  style_tab={styles.style_tab}
                  onChange={(n) => setTab(n)}
                />
                <Row>
                  <Select select={mode} list={modes} onSelect={(v) => { setTab(0); setMode(v) }} width="200px" />
                </Row>
              </Row>
              <Row className={styles.row_input}>
                {Object.keys(postitionsChecked).length > 0 && (
                  <Row className={styles.row_select}>
                    <Row>
                      {/* <Button type={TYPE_BUTTONS.WHITE} style={{ marginRight: '15px' }} onClick={() => { }}>
                    Сделать
                  </Button> */}

                      <Button
                        type={TYPE_BUTTONS.RED}
                        style={{ marginRight: '25px' }}
                        onClick={() => {
                          setCheckAll(false);
                          setPositionsChecked({});
                          setTimeout(setInputFocus, 1000);
                        }}
                      >
                        Очистить выбор
                      </Button>
                      {console.log(lists.ids.filter(listId => Object.keys(postitionsChecked).includes(listId))
                        .reduce((acc, listId) => {
                          const itemsId = lists.byIds[listId].items
                          acc.push(...itemsId)
                          return acc
                        }, []),)}
                      <div style={{ margin: ' 0px 20px 0px 0px' }}>
                        <Select
                          label="Лист"
                          width={'200px'}
                          select={listMarketsSelect}
                          valueFn={(v) => v.name}
                          list={LIST_MARKETS}
                          // style={{ marginRight: '10px' }}
                          onSelect={async (v) => {
                            await onChangeOrdersList({
                              orderProductIds: lists.ids.filter(listId => Object.keys(postitionsChecked).includes(listId))
                                .reduce((acc, listId) => {
                                  const itemsId = lists.byIds[listId].items
                                  acc.push(...itemsId)
                                  return acc
                                }, []),
                              field: 'list_markets',
                              value: v.value || [],
                            });
                            setPositionsChecked({})
                            // setListMarketsSelect(LIST_MARKETS.find(lm => !lm.value))

                          }}
                        />
                      </div>
                    </Row>
                  </Row>
                )}
              </Row>

              <Row spaceBetween={true}>
                <Row style={{ height: '70px' }}>
                  <Select
                    list={MARKETS_LIST}
                    select={market}
                    // disabled={market === 'Все'}
                    label="Площадка"
                    onSelect={(v) => setMarket(v)}
                    width={'150px'}
                    style={{ marginTop: '15px' }}
                  />
                </Row>
              </Row>
            </WhiteBlock>

            <Table styles={styles.table}>
              <TableHeader whiteHeader>
                <HeaderTitle width={WIDTH_POSTING[9]}>
                  <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[7]} centerText={true}>
                  Дата
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Количество заказов
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[7]}>Поставщик</HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[10]}>Площадка</HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[7]} centerText={true}>
                  Лист
                </HeaderTitle>
              </TableHeader>
              {lists.ids.map((listId) => {
                const list = lists.byIds[listId]
                const data_line = list._id;
                return (
                  <TableLine key={`${data_line.dates_create}-${data_line.provider_id}`}>
                    <TableCell width={WIDTH_POSTING[9]}>
                      <CheckButton
                        checked={postitionsChecked[listId]}
                        onSelect={() => changePositionsCheck(listId)}
                      />
                    </TableCell>

                    <TableCell width={WIDTH_POSTING[7]} center={true}>
                      {moment(data_line.dates_create).format('DD.MM.YYYY HH:mm')}
                    </TableCell>
                    <TableCell width={WIDTH_POSTING[10]} center={true}>
                      {list.count}
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold', fontSize: '16px' }} width={WIDTH_POSTING[7]}>
                      {getProviderNew(data_line.provider_id, allProviders)?.name}
                    </TableCell>
                    <TableCell width={WIDTH_POSTING[10]} center={true}>{data_line.market}</TableCell>
                    <TableCell center={true}>
                      <Column>
                        <div className={styles.div_line}>
                          <Select
                            width={'200px'}
                            select={LIST_MARKETS.find((lm) => lm.value?.join('') === data_line?.list_markets?.join(''))}
                            valueFn={(v) => v.name}
                            list={LIST_MARKETS.filter(lm => !lm.value || lm.value.includes(data_line.market))}
                            // style={{ marginRight: '10px' }}
                            onSelect={async (v) => {
                              await onChangeOrdersList({
                                orderProductIds: list.items,
                                field: 'list_markets',
                                value: v.value || [],
                              });
                            }}
                          />
                        </div>
                      </Column>
                    </TableCell>
                  </TableLine>
                );
              })}
            </Table>
          </>
        )}
      </Content >
      {showOrderTable && (
        <OrderTable
          orderId={id}
          providers={allProviders}
          providerId={provider.id}
          listMarkets={listMarkets}
          market={market}
          close={() => {
            setShowOrderTable(false);
          }}
        />
      )
      }
      {
        showModalDelete && (
          <DeletePopUp
            doDelete={modalFunctionDelete}
            close={() => {
              setShowModalDelete(false);
            }}
          />
        )
      }

      {
        showModalChangeBill.isActive && (
          <ChangeBillPopUp
            IP_LIST={IP_LIST}
            bill={showModalChangeBill.bill}
            providers={allProviders}
            onChange={onChangeBill}
            close={() => {
              setShowModalChangeBill({ isActive: false });
            }}
          />
        )
      }
    </>
  );
}

export default OrderPage;
